// src/components/SignUp.js
import React, { useState, useEffect } from "react";
import axios from 'axios';
import Layout, { Container } from "../components/layout";
import { useNavigate } from 'react-router-dom';
import { CountryAndStateData } from "../constants/constant";
import { toast } from "react-toastify";
import { apiurl } from "../config/config";
import { IoClose } from "react-icons/io5";





const VendorCreate = () => {
  const navigate = useNavigate();

  const [errorMessage, setErrorMessage] = useState("");
  const [otpModalOpen, setOtpModalOpen] = useState(false);
  console.log("otpModalOpen", otpModalOpen);
  const [otp, setOtp] = useState("");
  const [resendTimer, setResendTimer] = useState(59);
  // const [otpVerified, setOtpVerified] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState('IN');
  const [selectedState, setSelectedState] = useState('');
  console.log("selectedCountry", selectedCountry)
  console.log("selectedState", selectedState)

  const [formData, setFormData] = useState({
    storeName: "",
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    password: "",
    confirmPassword: "",
    country: selectedCountry,
    address: "",
    city: "",
    state: selectedState,
    zipcode: "",
    purpose: "",
    termsAccepted: false,
  });

  console.log("formData", formData);

  // const requestData = {
  //   storeName: formData.storeName,
  //   // ownerName: "Shubham Sharma",
  //   ownerName: `${formData.firstName} ${formData.lastName}`,
  //   ownerEmail: formData.email,
  //   ownerPhone: formData.phone,
  //   ownerPassword: formData.password,
  //   addressDetails: {
  //     address: formData.address,
  //     city: formData.city,
  //     province: formData.state,
  //     zip: formData.zipcode,
  //     country: formData.country,
  //     province_code: "",
  //     country_code: formData.country
  //   }
  // }

  // const handleInputChange = (e) => {
  //   setErrorMessage("");
  //   const { name, value, type, checked } = e.target;
  //   setFormData({
  //     ...formData,
  //     [name]: type === "checkbox" ? checked : value,
  //   });
  // };

  const handleInputChange = (e) => {
    setErrorMessage("");
    const { name, value, type, checked } = e.target;

    // Apply regex only for the "phone" field
    if (name === "phone") {
      const numericValue = value.replace(/\D/g, "");
      if (numericValue.length > 10) return;
      setFormData({
        ...formData,
        [name]: numericValue,
      });
    } else {
      setFormData({
        ...formData,
        [name]: type === "checkbox" ? checked : value,
      });
    }
  };
  useEffect(() => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      country: selectedCountry,
    }));
  }, [selectedCountry]);

  useEffect(() => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      state: selectedState,
    }));
  }, [selectedState]);

  const sendOtp = async (e) => {
    e.preventDefault(); // Prevent default form submission behavior

    try {
      // Combine firstName and lastName for ownerName
      const ownerName = `${formData.firstName} ${formData.lastName}`;

      // Prepare the payload
      const payload = {
        ownerName,
        recipientEmail: formData.email,
        storeName: formData.storeName,
      };

      console.log("Payload being sent:", payload);

      // Make the API call
      const response = await axios.post(
        `${apiurl}/admin/v1/otp/generate`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      console.log("response",response);
      // Handle response
      if (response?.data?.success === "true") {
        toast.success(response?.data?.message || "OTP sent successfully");
        console.log("OTP Modal Opened:", response?.data?.message);
        setOtpModalOpen(true);
      } else {
        toast.error(response?.data?.message || "OTP Sent failure, Please try again");
      }
    } catch (error) {
      // Handle and log errors
      console.error("Error generating OTP:", error.response?.data || error.message);
      toast.error("An error occurred while sending OTP. Please try again later.");
    }
  };



  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   const config = {
  //     method: 'post',
  //     maxBodyLength: Infinity,
  //     url: `${apiurl}/api/vendor/create`,
  //     headers: {
  //       'Content-Type': 'application/json'
  //     },
  //     data: JSON.stringify(requestData)
  //   };

  //   try {
  //     const response = await axios.request(config);
  //     console.log('Response:', (response?.data?.message));
  //     console.log('Response success:', (response?.data?.success));
  //     if (response?.data?.success === true) {
  //       navigate("/thankyou");
  //     } else {
  //       setErrorMessage(response?.data?.message);
  //     }
  //   } catch (error) {
  //     console.error('Error:', error);
  //   }
  // };



  // Resend Timer Logic
  useEffect(() => {
    let timer;
    if (resendTimer > 0) {
      timer = setTimeout(() => setResendTimer((prev) => prev - 1), 1000);
    }
    return () => clearTimeout(timer);
  }, [resendTimer]);

  // Handle "Create" Button
  // const handleCreate = async (e) => {
  //   e.preventDefault();
  //   setErrorMessage("");

  //   if (formData.password !== formData.confirmPassword) {
  //     setErrorMessage("Passwords do not match.");
  //     return;
  //   }

  //   const payload = {
  //     email: formData.email,
  //     phone: formData.phone,
  //   };

  //   try {
  //     const response = await axios.post(
  //       "https://example.com/api/send-otp",
  //       payload
  //     );
  //     if (response.data.success) {
  //       setOtpModalOpen(true);
  //     } else {
  //       setErrorMessage(response.data.message || "Failed to send OTP.");
  //     }
  //   } catch (error) {
  //     setErrorMessage("Something went wrong while sending OTP.");
  //   }
  // };

  // Handle OTP Verification
  const handleOtpSubmit = async () => {
    try {
      // Prepare the payload
      const payload = {
        otp,
        email: formData.email,
      };

      // console.log("Payload being sent for OTP verification:", payload);

      // API call
      const response = await axios.post(
        `${apiurl}/admin/v1/otp/verify`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response?.data?.success === "true") {
        toast.success(response?.data?.message || "OTP verified successfully");
        setOtpModalOpen(false);
        createVendor();
      } else {
        toast.error(response?.data?.message || "OTP verification failed. Please try again.");
        createVendor();
      }
    } catch (error) {
      // Handle errors
      console.error("Error verifying OTP:", error.response?.data || error.message);
      toast.error("An error occurred during OTP verification. Please try again.");
    }
  };

  // Create Vendor After OTP Verification
  const createVendor = async () => {
    const requestData = {
      storeName: formData.storeName,
      ownerName: `${formData.firstName} ${formData.lastName}`,
      ownerEmail: formData.email,
      ownerPhone: formData.phone,
      ownerPassword: formData.password,
      addressDetails: {
        address: formData.address,
        city: formData.city,
        province: formData.state,
        zip: formData.zipcode,
        country: formData.country,
      },
    };

    try {
      const response = await axios.post(
        `${apiurl}/api/vendor/create`,
        requestData
      );
      if (response.data.success) {
        navigate("/thankyou");
      } else {
        setErrorMessage(response.data.message || "Failed to create vendor.");
      }
    } catch (error) {
      setErrorMessage("Something went wrong while creating vendor.");
    }
  };

  // Handle Resend OTP
  const handleResendOtp = async () => {
    setResendTimer(59);
    // await handleCreate();
  };




  const handleCountryChange = (e) => {
    setSelectedCountry(e.target.value);
    setSelectedState(''); // Reset state selection
  };

  const handleStateChange = (e) => {
    setSelectedState(e.target.value);
  };

  return (
    <Layout>
      <Container overflow={'overflow-scroll'}>

        <div className="flex flex-col gap-8 justify-center min-h-screen md:px-8">
          <div className="bg-slate-950 flex flex-col justify-between align-middle p-6 md:p-10 my-9 text-white rounded-lg">
            <div className="w-[100%] h-[50%] flex flex-col justify-evenly">
              {/* <img src="/inficonnect/inficonnectLogo.png" alt="SignupImage" className="w-[20%] mx-auto"></img> */}
              <h2 className="text-2xl md:text-3xl text-white font-bold text-center mb-6">Sign Up</h2>
              <h1 className="text-2xl md:text-4xl font-bold text-center">Welcome to Inficonnect! Building the future of digital experiences.</h1>
              <p className="px-16 text-center text-sm mt-4 text-slate-300">Inficonnect is your one-stop platform for building meaningful connections between vendors and brands. Whether you're a vendor looking to showcase your products to top brands or a brand seeking reliable vendors to boost your supply chain, Inficonnect makes it effortless and efficient.</p>
            </div>
            {/* <div className="w-[100%] h-[50%] flex items-center justify-center">
            <img src="/signupImageBlackandwhite.png" alt="SignupImage" className="w-[70%] h-auto"></img>
          </div> */}
          </div>
          <div className="rounded-lg w-full p-8">
            <form className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="md:col-span-2">
                <label className="block text-slate-600 mb-2">Store Name</label>
                <input
                  type="text"
                  name="storeName"
                  value={formData.storeName}
                  onChange={handleInputChange}
                  className="w-full px-4 py-3 border border-gray-300   focus:outline-none focus:ring-2 focus:ring-slate-400"
                  placeholder="Enter your Store name"
                  required
                />
              </div>
              {/* First Name */}
              <div>
                <label className="block text-slate-600 mb-2">First Name</label>
                <input
                  type="text"
                  name="firstName"
                  value={formData.firstName}
                  onChange={handleInputChange}
                  className="w-full px-4 py-3 border border-gray-300   focus:outline-none focus:ring-2 focus:ring-slate-400"
                  placeholder="Enter your first name"
                  required
                />
              </div>

              {/* Last Name */}
              <div>
                <label className="block text-slate-600 mb-2">Last Name</label>
                <input
                  type="text"
                  name="lastName"
                  value={formData.lastName}
                  onChange={handleInputChange}
                  className="w-full px-4 py-3 border border-gray-300   focus:outline-none focus:ring-2 focus:ring-slate-400"
                  placeholder="Enter your last name"
                  required
                />
              </div>

              {/* Email */}
              <div>
                <label className="block text-slate-600 mb-2">Email</label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  className="w-full px-4 py-3 border border-gray-300   focus:outline-none focus:ring-2 focus:ring-slate-400"
                  placeholder="Enter your email"
                  required
                />
              </div>

              {/* Phone */}
              <div>
                <label className="block text-slate-600 mb-2">Phone</label>
                <input
                  type="tel"
                  name="phone"
                  value={formData.phone}
                  onChange={handleInputChange}
                  className="w-full px-4 py-3 border border-gray-300   focus:outline-none focus:ring-2 focus:ring-slate-400"
                  placeholder="Enter your phone number"
                  required
                />
              </div>

              {/* Password */}
              <div>
                <label className="block text-slate-600 mb-2">Password</label>
                <div className="relative">
                  <input
                    type={showPassword ? "text" : "password"}
                    name="password"
                    value={formData.password}
                    onChange={handleInputChange}
                    className="w-full px-4 py-3 border border-gray-300   focus:outline-none focus:ring-2 focus:ring-slate-400"
                    placeholder="Enter your password"
                    required
                  />
                  <span
                    onClick={() => setShowPassword(!showPassword)}
                    className="absolute inset-y-0 right-3 flex items-center cursor-pointer text-gray-500"
                  >
                    {showPassword ? "🙈" : "👁️"}
                  </span>
                </div>
              </div>

              {/* Confirm Password */}
              <div>
                <label className="block text-slate-600 mb-2">Confirm Password</label>
                <input
                  type="password"
                  name="confirmPassword"
                  value={formData.confirmPassword}
                  onChange={handleInputChange}
                  className="w-full px-4 py-3 border border-gray-300   focus:outline-none focus:ring-2 focus:ring-slate-400"
                  placeholder="Confirm your password"
                  required
                />
              </div>


              {/* Country Selector */}
              {/* <select value={selectedCountry} onChange={handleCountryChange}>
                  <option value="">Select Country</option>
                  {Object.keys(CountryAndStateData).map((code) => (
                    <option key={code} value={code}>
                      {CountryAndStateData[code]?.name}
                    </option>
                  ))}
                </select> */}
              <div>
                <label className="block text-slate-600 mb-2">Country</label>
                <select
                  value={selectedCountry}
                  onChange={handleCountryChange}
                  className="w-full px-4 py-3 border border-gray-300 focus:outline-none focus:ring-2 focus:ring-slate-400"
                  required
                >
                  <option value="">Select Country</option>
                  {Object.keys(CountryAndStateData).map((code) => (
                    <option key={code} value={code}>
                      {CountryAndStateData[code]?.name}
                    </option>
                  ))}
                </select>
              </div>


              {/* State Selector */}
              {/* {selectedCountry && (
                  <select value={selectedState} onChange={handleStateChange}>
                    <option value="">Select State</option>
                    {Object.entries(CountryAndStateData[selectedCountry].states).map(([code, name]) => (
                      <option key={code} value={code}>
                        {name}
                      </option>
                    ))}
                  </select>
                )} */}

              {selectedCountry && (
                <div>
                  <label className="block text-slate-600 mb-2">State</label>
                  <select
                    value={selectedState}
                    onChange={handleStateChange}
                    className="w-full px-4 py-3 border border-gray-300 focus:outline-none focus:ring-2 focus:ring-slate-400"
                    required
                  >
                    <option value="">Select State</option>
                    {Object.entries(CountryAndStateData[selectedCountry].states).map(([code, name]) => (
                      <option key={code} value={code}>
                        {name}
                      </option>
                    ))}
                  </select>
                </div>
              )}


              {/* Country */}
              {/* <div className="md:col-span-2">
                <label className="block text-slate-600 mb-2">Country</label>
                <select
                  name="country"
                  value={formData.country}
                  onChange={handleInputChange}
                  className="w-full px-4 py-3 border border-gray-300   focus:outline-none focus:ring-2 focus:ring-slate-400"
                  required
                >
                
                  <option value="">Select Country</option>
                  {Object.keys(CountryAndStateData).map((code) => (
                    <option key={code} value={code}>
                      {CountryAndStateData[code]?.name}
                    </option>
                  ))}


                </select>
              </div>

              {selectedCountry && (
                <select value={selectedState} onChange={handleStateChange}>
                  <option value="">Select State</option>
                  {Object.entries(CountryAndStateData[selectedCountry].states).map(([code, name]) => (
                    <option key={code} value={code}>
                      {name}
                    </option>
                  ))}
                </select>
              )} */}

              {/* Address */}
              <div className="md:col-span-2">
                <label className="block text-slate-600 mb-2">Address</label>
                <textarea
                  name="address"
                  value={formData.address}
                  onChange={handleInputChange}
                  className="w-full px-4 py-3 border border-gray-300   focus:outline-none focus:ring-2 focus:ring-slate-400"
                  placeholder="Enter your address"
                  required
                />
              </div>

              {/* City, State, Zipcode */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:col-span-2">
                <div>
                  <label className="block text-slate-600 mb-2">City</label>
                  <input
                    type="text"
                    name="city"
                    value={formData.city}
                    onChange={handleInputChange}
                    className="w-full px-4 py-3 border border-gray-300   focus:outline-none focus:ring-2 focus:ring-slate-400"
                    placeholder="City"
                    required
                  />
                </div>
                {/* <div>
                  <label className="block text-slate-600 mb-2">State</label>
                  <input
                    type="text"
                    name="state"
                    value={formData.state}
                    onChange={handleInputChange}
                    className="w-full px-4 py-3 border border-gray-300   focus:outline-none focus:ring-2 focus:ring-slate-400"
                    placeholder="State"
                    required
                  />
                </div> */}
                <div>
                  <label className="block text-slate-600 mb-2">Zipcode</label>
                  <input
                    type="text"
                    name="zipcode"
                    value={formData.zipcode}
                    onChange={handleInputChange}
                    className="w-full px-4 py-3 border border-gray-300   focus:outline-none focus:ring-2 focus:ring-slate-400"
                    placeholder="Zipcode"
                    required
                  />
                </div>
              </div>

              {/* Purpose */}
              <div className="md:col-span-2">
                <label className="block text-slate-600 mb-2">Purpose</label>
                <select
                  name="purpose"
                  value={formData.purpose}
                  onChange={handleInputChange}
                  className="w-full px-4 py-3 border border-gray-300   focus:outline-none focus:ring-2 focus:ring-slate-400"
                  required
                >
                  <option value="" disabled>Select your purpose</option>
                  <option value="personal">Personal Use</option>
                  <option value="business">Business Use</option>
                  <option value="other">Other</option>
                </select>
              </div>


              {/* Terms and Conditions */}
              <div className="flex items-center md:col-span-2">
                <input
                  type="checkbox"
                  name="termsAccepted"
                  checked={formData.termsAccepted}
                  onChange={handleInputChange}
                  className="mr-2"
                  required
                />
                <label className="text-slate-600">I agree to the terms and conditions</label>
              </div>

              {errorMessage !== "" ? <p className="text-red-500">{errorMessage}</p> : null}

              {/* Submit Button */}
              <div className="flex items-center md:col-span-2">

                <div className="w-full flex justify-center mt-4">
                  <button
                    type="submit"
                    className="w-2/4 md:w-3/4 max-w-xs text-sm md:text-base bg-slate-800 text-white py-3   hover:bg-slate-900 transition duration-300"
                    onClick={sendOtp}
                    // disabled={termsAccepted === false}
                  // onClick={()=>setOtpModalOpen(true)}
                  >
                    Sign Up
                  </button>
                </div>
              </div>

            </form>
          </div>
        </div>


        {/* <div className="flex justify-center items-center min-h-screen bg-gray-100">
          <div className="bg-white p-8 rounded-lg shadow-md w-full max-w-3xl">
            <h2 className="text-2xl font-bold text-center mb-6">Sign Up</h2>
            <form onSubmit={handleCreate} className="grid gap-6">
              <input
                type="text"
                name="storeName"
                placeholder="Store Name"
                value={formData.storeName}
                onChange={handleInputChange}
                required
                className="border p-2 w-full"
              />
              <button
                type="submit"
                className="bg-blue-500 text-white py-2 px-4 rounded hover:bg-blue-600"
              >
                Create
              </button>
            </form>
            {errorMessage && <p className="text-red-500 mt-2">{errorMessage}</p>}
          </div>
        </div> */}

        {/* OTP Modal */}
        {otpModalOpen && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center">
            <div className="relative bg-white p-8 rounded shadow-md w-full max-w-md">
            <button
                onClick={()=>setOtpModalOpen(false)}
                className="absolute top-2 right-2 text-sm flex items-center justify-center w-6 h-6 rounded-sm border border-gray-400 bg-white text-gray-400 hover:border-gray-600 hover:text-gray-600 transition-all duration-200"
              >
                <IoClose />
              </button>
              <h2 className="text-xl font-bold mb-4">Enter OTP</h2>
              <input
                type="text"
                value={otp}
                onChange={(e) => setOtp(e.target.value)}
                placeholder="Enter 6-digit OTP"
                className="border p-2 w-full mb-4"
                maxLength={6}
              />
              <div className="flex justify-between items-center">
                <button
                  onClick={handleOtpSubmit}
                  disabled={otp.length !== 6}
                  className={`py-2 px-4 rounded ${otp.length === 6
                    ? "bg-blue-500 text-white hover:bg-blue-600"
                    : "bg-gray-300 text-gray-500"
                    }`}
                >
                  Submit
                </button>
                <button
                  onClick={handleResendOtp}
                  disabled={resendTimer > 0}
                  className={`py-2 px-4 rounded ${resendTimer > 0
                    ? "bg-gray-300 text-gray-500"
                    : "bg-blue-500 text-white hover:bg-blue-600"
                    }`}
                >
                  Resend OTP ({resendTimer}s)
                </button>
              </div>
            </div>
          </div>
        )}

      </Container>

    </Layout>
  );
}

export default VendorCreate;



// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import Layout, { Container } from "../components/layout";
// import { useNavigate } from "react-router-dom";
// import { CountryAndStateData } from "../constants/constant";

// const VendorCreate = () => {
//   const navigate = useNavigate();

//   const [formData, setFormData] = useState({
//     storeName: "",
//     firstName: "",
//     lastName: "",
//     email: "",
//     phone: "",
//     password: "",
//     confirmPassword: "",
//     country: "",
//     state: "",
//     address: "",
//     city: "",
//     zipcode: "",
//   });

//   const [errorMessage, setErrorMessage] = useState("");
//   const [otpModalOpen, setOtpModalOpen] = useState(false);
//   const [otp, setOtp] = useState("");
//   const [resendTimer, setResendTimer] = useState(59);
//   const [otpVerified, setOtpVerified] = useState(false);
//   const [showPassword, setShowPassword] = useState(false);

//   // Dynamic States
//   const [states, setStates] = useState([]);

//   // Handle Input Change
//   const handleInputChange = (e) => {
//     const { name, value, type, checked } = e.target;

//     if (name === "phone") {
//       const numericValue = value.replace(/\D/g, "");
//       if (numericValue.length > 10) return;
//       setFormData({ ...formData, [name]: numericValue });
//     } else {
//       setFormData({ ...formData, [name]: type === "checkbox" ? checked : value });
//     }

//     if (name === "country") {
//       setStates(CountryAndStateData[value] || []);
//       setFormData({ ...formData, country: value, state: "" }); // Reset state
//     }
//   };

//   // Handle Form Submission
//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (formData.password !== formData.confirmPassword) {
//       setErrorMessage("Passwords do not match.");
//       return;
//     }

//     const requestData = {
//       storeName: formData.storeName,
//       ownerName: `${formData.firstName} ${formData.lastName}`,
//       ownerEmail: formData.email,
//       ownerPhone: formData.phone,
//       ownerPassword: formData.password,
//       addressDetails: {
//         address: formData.address,
//         city: formData.city,
//         province: formData.state,
//         zip: formData.zipcode,
//         country: formData.country,
//       },
//     };

//     try {
//       const response = await axios.post(
//         `${apiurl}/api/vendor/create`,
//         requestData
//       );
//       if (response.data.success) {
//         navigate("/thankyou");
//       } else {
//         setErrorMessage(response.data.message || "Vendor creation failed.");
//       }
//     } catch (error) {
//       console.error("Error:", error);
//       setErrorMessage("An error occurred while creating the vendor.");
//     }
//   };

//   // Resend OTP Timer
//   useEffect(() => {
//     let timer;
//     if (resendTimer > 0) {
//       timer = setTimeout(() => setResendTimer((prev) => prev - 1), 1000);
//     }
//     return () => clearTimeout(timer);
//   }, [resendTimer]);

//   console.log("states",states);
//   return (
//     <Layout>
//       <Container overflow="overflow-scroll">
//         <div className="flex flex-col gap-8 justify-center min-h-screen md:px-8">
//           <div className="bg-slate-950 flex flex-col justify-between align-middle p-6 md:p-10 my-9 text-white rounded-lg">
//             <h2 className="text-3xl font-bold text-center mb-6">Sign Up</h2>
//             <h1 className="text-4xl font-bold text-center">Welcome to Inficonnect!</h1>
//             <p className="px-16 text-center text-sm mt-4 text-slate-300">
//               Build meaningful connections between vendors and brands with Inficonnect.
//             </p>
//           </div>
//           <div className="rounded-lg w-full p-8">
//             <form onSubmit={handleSubmit} className="grid grid-cols-1 md:grid-cols-2 gap-6">
//               {/* Store Name */}
//               <div className="md:col-span-2">
//                 <label className="block text-slate-600 mb-2">Store Name</label>
//                 <input
//                   type="text"
//                   name="storeName"
//                   value={formData.storeName}
//                   onChange={handleInputChange}
//                   className="w-full px-4 py-3 border border-gray-300 focus:outline-none focus:ring-2 focus:ring-slate-400"
//                   placeholder="Enter your Store name"
//                   required
//                 />
//               </div>

//               {/* First & Last Name */}
//               <div>
//                 <label className="block text-slate-600 mb-2">First Name</label>
//                 <input
//                   type="text"
//                   name="firstName"
//                   value={formData.firstName}
//                   onChange={handleInputChange}
//                   className="w-full px-4 py-3 border border-gray-300 focus:outline-none focus:ring-2 focus:ring-slate-400"
//                   placeholder="First name"
//                   required
//                 />
//               </div>
//               <div>
//                 <label className="block text-slate-600 mb-2">Last Name</label>
//                 <input
//                   type="text"
//                   name="lastName"
//                   value={formData.lastName}
//                   onChange={handleInputChange}
//                   className="w-full px-4 py-3 border border-gray-300 focus:outline-none focus:ring-2 focus:ring-slate-400"
//                   placeholder="Last name"
//                   required
//                 />
//               </div>

//               {/* Email & Phone */}
//               <div>
//                 <label className="block text-slate-600 mb-2">Email</label>
//                 <input
//                   type="email"
//                   name="email"
//                   value={formData.email}
//                   onChange={handleInputChange}
//                   className="w-full px-4 py-3 border border-gray-300 focus:outline-none focus:ring-2 focus:ring-slate-400"
//                   placeholder="Email address"
//                   required
//                 />
//               </div>
//               <div>
//                 <label className="block text-slate-600 mb-2">Phone</label>
//                 <input
//                   type="tel"
//                   name="phone"
//                   value={formData.phone}
//                   onChange={handleInputChange}
//                   className="w-full px-4 py-3 border border-gray-300 focus:outline-none focus:ring-2 focus:ring-slate-400"
//                   placeholder="Phone number"
//                   required
//                 />
//               </div>

//               {/* Password Fields */}
//               <div>
//                 <label className="block text-slate-600 mb-2">Password</label>
//                 <input
//                   type={showPassword ? "text" : "password"}
//                   name="password"
//                   value={formData.password}
//                   onChange={handleInputChange}
//                   className="w-full px-4 py-3 border border-gray-300 focus:outline-none focus:ring-2 focus:ring-slate-400"
//                   placeholder="Password"
//                   required
//                 />
//               </div>
//               <div>
//                 <label className="block text-slate-600 mb-2">Confirm Password</label>
//                 <input
//                   type="password"
//                   name="confirmPassword"
//                   value={formData.confirmPassword}
//                   onChange={handleInputChange}
//                   className="w-full px-4 py-3 border border-gray-300 focus:outline-none focus:ring-2 focus:ring-slate-400"
//                   placeholder="Confirm Password"
//                   required
//                 />
//               </div>

//               {/* Country and State */}
//               <div>
//                 <label className="block text-slate-600 mb-2">Country</label>
//                 <select
//                   name="country"
//                   value={formData.country}
//                   onChange={handleInputChange}
//                   className="w-full px-4 py-3 border border-gray-300 focus:outline-none focus:ring-2 focus:ring-slate-400"
//                   required
//                 >
//                   <option value="">Select Country</option>
//                   {Object.keys(CountryAndStateData).map((country) => (
//                     <option key={country} value={country}>
//                     {CountryAndStateData[country]?.name}
//                     </option>
//                   ))}
//                 </select>
//               </div>
//               <div>
//                 <label className="block text-slate-600 mb-2">State</label>
//                 <select
//                   name="state"
//                   value={formData.state}
//                   onChange={handleInputChange}
//                   className="w-full px-4 py-3 border border-gray-300 focus:outline-none focus:ring-2 focus:ring-slate-400"
//                   required
//                 >
//                   <option value="">Select State</option>
//                   {Object.keys(states.states).map(([code , value]) => (
//                     <option key={code} value={code}>
//                     {value} -- {states}
//                     </option>
//                   ))}
//                 </select>
//               </div>

//               {/* Address, City, Zip */}
//               <div className="md:col-span-2">
//                 <label className="block text-slate-600 mb-2">Address</label>
//                 <input
//                   type="text"
//                   name="address"
//                   value={formData.address}
//                   onChange={handleInputChange}
//                   className="w-full px-4 py-3 border border-gray-300 focus:outline-none focus:ring-2 focus:ring-slate-400"
//                   placeholder="Street address"
//                   required
//                 />
//               </div>
//               <div>
//                 <label className="block text-slate-600 mb-2">City</label>
//                 <input
//                   type="text"
//                   name="city"
//                   value={formData.city}
//                   onChange={handleInputChange}
//                   className="w-full px-4 py-3 border border-gray-300 focus:outline-none focus:ring-2 focus:ring-slate-400"
//                   placeholder="City"
//                   required
//                 />
//               </div>
//               <div>
//                 <label className="block text-slate-600 mb-2">Zip Code</label>
//                 <input
//                   type="text"
//                   name="zipcode"
//                   value={formData.zipcode}
//                   onChange={handleInputChange}
//                   className="w-full px-4 py-3 border border-gray-300 focus:outline-none focus:ring-2 focus:ring-slate-400"
//                   placeholder="ZIP Code"
//                   required
//                 />
//               </div>

//               {/* Submit Button */}
//               <div className="md:col-span-2">
//                 <button
//                   type="submit"
//                   className="w-full py-3 bg-slate-600 text-white font-bold rounded-md hover:bg-slate-700"
//                 >
//                   Create Vendor
//                 </button>
//               </div>
//             </form>
//             {errorMessage && <p className="text-red-500 mt-4">{errorMessage}</p>}
//           </div>
//         </div>
//       </Container>
//     </Layout>
//   );
// };

// export default VendorCreate;
